import React from "react";
import clsx from "clsx";
import { TableHeaderProps } from "../types";
import { Label4 } from "../../typography/components/Label";

const HiddenHeader: React.FC<TableHeaderProps> = ({ value }) => {
  return <span className="sr-only">{value}</span>;
};

const TableHeader: React.FC<TableHeaderProps> = ({
  value,
  isHidden = false,
  className,
}) => {
  return (
    <th
      scope="col"
      className={clsx("pr-3 pb-5 text-left uppercase", className)}
    >
      <Label4>{isHidden ? <HiddenHeader value={value} /> : value}</Label4>
    </th>
  );
};

export default TableHeader;
